export default __webpack_public_path__ + "static/media/profile-img.f08b3e44.png";